import React from "react";
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Icon,
  Button,
  Link,
} from "@chakra-ui/react";
import { MdCancel, MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../Context/ChatProvider";
import { SUPPORT_EMAIL } from "../config/constants";

const VendorRejected = () => {
  const navigate = useNavigate();
  const { setUser } = ChatState();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userInfo");
    setUser(null);
    navigate("/login");
  };

  return (
    <Container maxW="xl" centerContent>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        width="100%"
      >
        <VStack
          spacing={6}
          bg="white"
          p={8}
          borderRadius="lg"
          borderWidth="1px"
          boxShadow="lg"
          textAlign="center"
        >
          <Icon as={MdCancel} w={20} h={20} color="red.500" />

          <Heading size="xl" color="gray.700">
            Account Deactivated
          </Heading>

          <Text fontSize="lg" color="gray.600" maxW="md">
            Your vendor account has been deactivated and you currently do not
            have access to the platform.
          </Text>

          <Box
            bg="red.50"
            p={4}
            borderRadius="md"
            borderWidth="1px"
            borderColor="red.200"
            width="100%"
          >
            <VStack spacing={3}>
              <Icon as={MdEmail} w={8} h={8} color="red.500" />
              <Text fontSize="md" fontWeight="semibold" color="gray.700">
                Think this is a mistake?
              </Text>
              <Text fontSize="sm" color="gray.600">
                Please contact us at:
              </Text>
              <Link
                href={`mailto:${SUPPORT_EMAIL}`}
                fontSize="lg"
                color="blue.500"
                fontWeight="bold"
                _hover={{ textDecoration: "underline" }}
              >
                {SUPPORT_EMAIL}
              </Link>
            </VStack>
          </Box>

          <Text fontSize="sm" color="gray.500" maxW="md">
            If you believe this deactivation was made in error, please reach out
            to our support team for assistance.
          </Text>

          <Button
            colorScheme="red"
            variant="solid"
            onClick={handleLogout}
            mt={4}
          >
            Logout
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export default VendorRejected;
